import { useContext, useCallback } from 'react';
import { AxiosError } from 'axios';

import { NotificationContext } from '../App';
import { SnackbarType } from '../types/enums';

const useErrorHandler = () => {
  const notify = useContext(NotificationContext);

  const handler = useCallback(
    ({ response }: AxiosError<{ error?: string[]; message?: string }>) => {
      if (response?.status === 400) {
        notify(
          response?.data?.error?.join(' ') ||
            'Unexpected error, please try again later or reach out to us!',
          SnackbarType.ERROR
        );
      }

      if (response?.status === 401) {
        notify(
          response?.data?.message || 'Unexpected error, please try again later or reach out to us!',
          SnackbarType.ERROR
        );
      }
    },
    []
  );

  return handler;
};

export default useErrorHandler;
